/**
 * 联网搜索开关的本地持久化（T12）。
 *
 * 约定的 localStorage key：`t12.searchEnabled`，以字符串 `'true'` / `'false'` 存放。
 * 读取时对「缺省 / 脏数据 / 存储不可用」一律回退为「关闭」，避免脏数据把联网检索
 * 意外打开；写入失败（隐私模式 / 配额）也不抛出，只影响跨会话持久化。
 */

export const SEARCH_ENABLED_STORAGE_KEY = 't12.searchEnabled';

function storage(): Storage | undefined {
  try {
    return typeof globalThis.localStorage === 'undefined' ? undefined : globalThis.localStorage;
  } catch {
    return undefined;
  }
}

/** 读取开关状态；未写入 / 损坏 / 无 localStorage 时回退为关闭。 */
export function loadSearchEnabled(): boolean {
  const store = storage();
  if (store === undefined) return false;
  try {
    return store.getItem(SEARCH_ENABLED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** 覆盖写入开关状态，返回归一化后的实际值。 */
export function saveSearchEnabled(enabled: boolean): boolean {
  const normalized = enabled === true;
  const store = storage();
  try {
    store?.setItem(SEARCH_ENABLED_STORAGE_KEY, normalized ? 'true' : 'false');
  } catch {
    // 存储不可用时忽略：当前会话内开关仍可用，只是不跨会话持久化。
  }
  return normalized;
}
